module.exports = __webpack_public_path__ + "static/media/status4.8e0a53ce.png";